class WaveAnimate {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const waveElements = document.querySelectorAll('.js-wave');
    waveElements.forEach((wave) => {
      const mm = gsap.matchMedia();
      let color, height, bones, amplitude, speed;
      mm.add('(max-width:1100px)', () => {
        color = wave.dataset.color ? wave.dataset.color : 'rgba(150, 97, 255, .8)';
        height = wave.dataset.spHeight ? wave.dataset.spHeight : 20;
        bones = wave.dataset.spBones ? wave.dataset.spBones : 1;
        amplitude = wave.dataset.spAmplitude ? wave.dataset.spAmplitude : 40;
        speed = wave.dataset.spSpeed ? wave.dataset.spSpeed : .25;
      })
      mm.add('(min-width:1100px)', () => {
        color = wave.dataset.color ? wave.dataset.color : 'rgba(150, 97, 255, .8)';
        height = wave.dataset.height ? wave.dataset.height : 20;
        bones = wave.dataset.bones ? wave.dataset.bones : 3;
        amplitude = wave.dataset.amplitude ? wave.dataset.amplitude : 40;
        speed = wave.dataset.speed ? wave.dataset.speed : .25;
      })
      wavify(wave, {
        container: 'svg',
        height: parseFloat(height),
        bones: parseFloat(bones),
        amplitude: parseFloat(amplitude),
        color: color,
        speed: parseFloat(speed)
      })
    })
  }
}